/**
 * LocalStorage helper functions for auth-related data
 */

/**
 * Get the last selected organization ID for a user from localStorage
 */
export const getLastSelectedOrganizationId = (userId: string): string | null => {
  try {
    return localStorage.getItem(`lastSelectedOrganization_${userId}`);
  } catch (error) {
    console.warn("Failed to get last selected organization from localStorage:", error);
    return null;
  }
};

/**
 * Save the last selected organization ID for a user to localStorage
 */
export const setLastSelectedOrganizationId = (
  userId: string,
  organizationId: string
): void => {
  try {
    localStorage.setItem(
      `lastSelectedOrganization_${userId}`,
      organizationId
    );
  } catch (error) {
    console.warn("Failed to save selected organization to localStorage:", error);
  }
};
